import { WasmLoader } from '@seddi/core';
import WaGarmentsGeometry from '@seddi/wa-garments-geometry';
import WaGarmentsGeometryWasm from '@seddi/wa-garments-geometry/lib/index.wasm';

/**
 * Garment geometry module.
 */
export class GarmentGeometryModule {
  /**
   * Init module.
   */
  static async init() {
    const geometryRes = await fetch(WaGarmentsGeometryWasm);
    const geometryWasm = new Uint8Array(await geometryRes.arrayBuffer());
    await WasmLoader.Load(WaGarmentsGeometry, geometryWasm);
  }
}
